export default __webpack_public_path__ + "static/garden_design24-80dce0d9b8235a7dcd28c9160605673e.webp";